export default __webpack_public_path__ + "static/media/checkmark.f6b4655d.svg";